import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import './Personal.css';
import useColumnsPersonal from "../../hooks/useColumnsPersonal";
import { AuthenticationService } from '../../services/authentication.service';
import * as Constants from '../../constants';
import PopUpPersonal from './NuevoPersonal';
import PopUpAsignarHabitacion from '../Empleado/AsignarHabitaciones';
import EmpleadoService from '../../services/empleado.service';
import UsuarioService from '../../services/usuario.service';

import Table from './TablePersonal';
import { useEstablishment } from '../../Context/EstablishmentContext';
import { IoSearch } from "react-icons/io5";
import { FaPlus } from "react-icons/fa";
import { FaFilter } from "react-icons/fa6";

const Personal = () => {
	const { establecimiento } = useEstablishment();
	const [listaTipos, setListaTipos] = useState([])
	const [listaUsuarios, setListaUsuarios] = useState([])
	//const [tipoUsuarioCamarero] = useState(3)
	const [filtroNombre, setFiltroNombre] = useState('');		
	const [activo, setActivo] = useState(1);
	const [selectedTipo, setSelectedTipo] = useState(null);
	const [selectedUsuario, setSelectedUsuario] = useState(null);
	const [connectedUser, setConnectedUser] = useState(null);
	const [seen, setSeen] = useState(false);
	const [seenAsignar, setSeenAsignar] = useState(false);
	//const [listaEmpleados, setListaEmpleados] = useState([]);
	const [t] = useTranslation("global");

	const authenticationService = new AuthenticationService();

	const tipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;//obtiene el tipo de trabajador
	const userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol de usuario

	const navigate = useNavigate();

	useEffect(() => {
		const authentication = authenticationService.getAuthenticationSession();

		if (authentication === null) {
			navigate(Constants.ROUTE_ROOT);
		} else {
			//obtenerListaEmpleados();
			
			if(authenticationService.getAuthenticationSession().user.idTipo !== Constants.ROLE_USUARIO_TRABAJADOR) {
				obtenerListaEmpleados();
				setSelectedTipo(null);
			}else {
				obtenerListaEmpleadosByParams(1,'',Constants.TIPO_EMPLEADO_CAMARERO, userRol)
				setSelectedTipo(Constants.TIPO_EMPLEADO_CAMARERO);
			}
				
			obtenerListaTipoEmpleados();

			setConnectedUser(authentication.user);

		}
	}, [navigate, establecimiento]);


	function togglePop() {

		if (selectedUsuario != null) {
			setSelectedUsuario(null);
		}

		setSeen(!seen);
	}

	function togglePopAsignar() {

		if (selectedUsuario != null) {
			setSelectedUsuario(null);
		}

		setSeenAsignar(!seenAsignar);
	}


	function guardarSelectedUsuario(usuario) {
		setSelectedUsuario(usuario);
	}

	const obtenerListaEmpleados = async () => {
		await UsuarioService.getUsuarios(establecimiento.id, userRol)
			.then(response => response.json())
			.then(data => setListaUsuarios(data));
	}
	
	const obtenerListaCamareros = () => {
		obtenerListaEmpleadosByParams(1,'',Constants.TIPO_EMPLEADO_CAMARERO, userRol)
	}

	const obtenerListaEmpleadosByParams = async (activo, filtroNombre, selectedTipo, userRol) => {
		await UsuarioService.getTiposUsuarioByParams(establecimiento.id, activo, filtroNombre, selectedTipo, userRol)
			.then(response => response.json())
			.then(data => setListaUsuarios(data))
	}
	
	const obtenerListaTipoEmpleados = async () => {
		await EmpleadoService.getTiposEmpleado()
			.then(response => response.json())
			.then(data => setListaTipos(data));
	}

	const optionsActivo = [
		{ value: 1, label: t('app.label.si') },
		{ value: 0, label: t('app.label.no') }
	];


	const onChangeFiltroActivo = (ev) => {
		setActivo(ev.value);
		
		if(authenticationService.getAuthenticationSession().user.idTipo !== Constants.ROLE_USUARIO_TRABAJADOR) {
			setSelectedTipo(null);
		} else {
			setSelectedTipo(Constants.TIPO_EMPLEADO_CAMARERO);
		}
		
		obtenerListaEmpleadosByParams(ev.value, filtroNombre, selectedTipo, userRol);
	}

	const onChangeFiltroNombre = (ev) => {
		setFiltroNombre(ev.target.value)		
		obtenerListaEmpleadosByParams(activo, ev.target.value, selectedTipo, userRol);
	}

	const onChangeFiltroTipo = (ev) => {
		setSelectedTipo(ev.id)
		obtenerListaEmpleadosByParams(activo, filtroNombre, ev.id, userRol);
	}

	const limpiarFiltros = () => {
		if(authenticationService.getAuthenticationSession().user.idTipo !== Constants.ROLE_USUARIO_TRABAJADOR) {
			obtenerListaEmpleados();
			//setSelectedTipo('');
			setSelectedTipo(null);
		}else {
			obtenerListaEmpleadosByParams(1,'',Constants.TIPO_EMPLEADO_CAMARERO, userRol)
			setSelectedTipo(Constants.TIPO_EMPLEADO_CAMARERO);
		}
		
		setActivo(1)
		setFiltroNombre('')
	}
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Puesto
	const getOptionValuePuestoEmpleado = option => option.id;


	return (
		<main className={'mainContainerPage'}>
			<section className="principal-container">

				<div className={'container-crearComponente'}>
					<h1 className={'title-Componente'}>{t("app.header.enlaces.personal")}</h1>
				
					{(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR)  && (
						<button className={'btn-general'} onClick={togglePop}><FaPlus size="10"/> <p className="txt-btn-nuevoCompt">{t("app.personal.nuevoUsuario")}</p></button>
					)}
					
					{seen ? <PopUpPersonal toggle={togglePop} 
						loadUsuarios={obtenerListaEmpleados} 
						selectedUsuario={selectedUsuario} 
						selectedEstablecimiento={establecimiento} 
						connectedUser={connectedUser}
						limpiarFiltros={limpiarFiltros}
						 /> : null}
					
					{seenAsignar ? <PopUpAsignarHabitacion toggleAsignar={togglePopAsignar} 
						loadUsuarios={obtenerListaEmpleados} 
						loadUsuariosCamareros={obtenerListaCamareros}
						selectedUsuario={selectedUsuario} 
						selectedEstablecimiento={establecimiento} 
						connectedUser={connectedUser} /> : null}
				</div>

				<div className="container-filtro-tabla">
					<div className="container-filtro-Personal">

						
							<div className={'div_img-filtroInputText'}>
								<IoSearch className="iconSearch" size="20" />
								<input placeholder={t("app.placeholder.buscarUsuario")} 
									type="search" 
									className={'filtroInputText'} 
									value ={filtroNombre}
									onChange={onChangeFiltroNombre} 
								/>
							</div>
							<div className="container-selects-btn-limpiarFiltro-Personal">
								<div className={'filterItemPersonal'} >
									<label className={'fieldsetLabel'}>{t("app.popup.label.activo")}</label>
									<Select
										className={'filtroSelect'}
										defaultValue={optionsActivo[0]}
										value={optionsActivo.find(e => e.value === activo)}
										options={optionsActivo}
										onChange={option => onChangeFiltroActivo(option)}
										isSearchable={false}
										styles={colorFiltros}	
									/>
								</div>
								
								{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? null : (
									<div className={'filterItemPersonal'} >
										<label className={'fieldsetLabel'}>{t("app.empleado.table.puesto")}</label>
										<Select
											getOptionValue={getOptionValuePuestoEmpleado}
											className="filtroSelect"
											placeholder={t("app.label.seleccionarPuesto")}
											key={selectedTipo || ''}
											value={listaTipos.find(e => e.id === selectedTipo)}
											onChange={onChangeFiltroTipo}
											options={listaTipos}
											isSearchable={false}
											formatOptionLabel={tipo => (
												<div>
													<span>{tipo.nombre}</span>
												</div>
											)}
											styles={colorFiltros}
										/>
									</div>
								)}
							
							<div className={'filterItemPersonal'} >
								<button className='btn-limpiarFiltro' onClick={() => { limpiarFiltros(); }}><FaFilter /> <p className="txt-btn-limpiarFiltro">{t("app.cama.limpiarFiltros")}</p></button>
							</div>
							
							</div>
						
					</div>
					
					<div className="containerTabla">
					<Table columns={useColumnsPersonal(togglePop, togglePopAsignar, guardarSelectedUsuario)} data={listaUsuarios} />
					</div>
				</div>

				
				
			</section>
		</main>
	)
}

export default Personal